__turbopack_context__.v({
  "active": "TypesOfLoads-module-scss-module__pKzx2a__active",
  "bookBtnWrapper": "TypesOfLoads-module-scss-module__pKzx2a__bookBtnWrapper",
  "count": "TypesOfLoads-module-scss-module__pKzx2a__count",
  "fadeInActive": "TypesOfLoads-module-scss-module__pKzx2a__fadeInActive",
  "heading": "TypesOfLoads-module-scss-module__pKzx2a__heading",
  "imgBox": "TypesOfLoads-module-scss-module__pKzx2a__imgBox",
  "label": "TypesOfLoads-module-scss-module__pKzx2a__label",
  "lorryImage": "TypesOfLoads-module-scss-module__pKzx2a__lorryImage",
  "lorryText": "TypesOfLoads-module-scss-module__pKzx2a__lorryText",
  "lorryTypeCard": "TypesOfLoads-module-scss-module__pKzx2a__lorryTypeCard",
  "lorryTypeCardWrap": "TypesOfLoads-module-scss-module__pKzx2a__lorryTypeCardWrap",
  "lorryTypesNav": "TypesOfLoads-module-scss-module__pKzx2a__lorryTypesNav",
  "main": "TypesOfLoads-module-scss-module__pKzx2a__main",
  "stateCard": "TypesOfLoads-module-scss-module__pKzx2a__stateCard",
  "stateCol": "TypesOfLoads-module-scss-module__pKzx2a__stateCol",
  "topStateRow": "TypesOfLoads-module-scss-module__pKzx2a__topStateRow",
});
